import { render, staticRenderFns } from "./CMLocationCRUDBody.vue?vue&type=template&id=05b52bbe&lang=pug"
import script from "./CMLocationCRUDBody.vue?vue&type=script&lang=js"
export * from "./CMLocationCRUDBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports